import dbHelper from '../util/db'
import debugHelper from '../util/debug'
import isTest from '../util/urltest'

var isDebug = debugHelper.isDebugMode()

var BOTTOM_NAV = {
  work: {
    id: 0,
    name: '工作',
    icon: 'work',
    tips: 0,
    click: {
      func: null,
      params: 'work'
    },
    visiable: true,
    disabled: false
  },
  message: {
    id: 1,
    name: '消息',
    icon: 'message',
    tips: 0,
    click: {
      func: null,
      params: 'sessionlist'
    },
    visiable: true,
    disabled: false
  },
  document: {
    id: 2,
    name: '文档',
    icon: 'folder',
    tips: 0,
    click: {
      func: null,
      params: 'document'
    },
    visiable: true,
    disabled: false
  },
  myinfo: {
    id: 1000,
    name: '我的',
    icon: 'info',
    tips: 0,
    click: {
      func: null,
      params: 'myinfo'
    },
    visiable: true,
    disabled: false
  },
}

// 比较底部导航栏的顺序(注：暂无使用处)
function compare(p) {
  //这是比较函数
  return function (m, n) {
    var a = m[p]
    var b = n[p]
    return a - b //升序
  }
}

export { compare, BOTTOM_NAV }
